import { useState, useEffect } from "react";

const CTA_LINK = "https://superprofile.bio/vp/6958efc5bfbbf90013a9338e";

export default function CountdownTimer() {
  const FOUR_HOURS = 4 * 60 * 60;

  const getTimeLeft = () => {
    const stored = sessionStorage.getItem("countdown_end");
    if (stored) {
      const diff = Math.floor((parseInt(stored) - Date.now()) / 1000);
      return diff > 0 ? diff : FOUR_HOURS;
    }
    const end = Date.now() + FOUR_HOURS * 1000;
    sessionStorage.setItem("countdown_end", end.toString());
    return FOUR_HOURS;
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          const end = Date.now() + FOUR_HOURS * 1000;
          sessionStorage.setItem("countdown_end", end.toString());
          return FOUR_HOURS;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;
  const pad = (n) => n.toString().padStart(2, "0");

  return (
    <div data-testid="countdown-timer" className="mt-6 text-center">
      <p className="text-red-600 font-semibold text-sm md:text-base mb-2 body-font flex items-center justify-center gap-2">
        <span className="inline-block animate-pulse text-lg">&#x26A0;&#xFE0F;</span>
        ಸೀಮಿತ ಸಮಯದ ಆಫರ್ – ಬೇಗ ಪಡೆಯಿರಿ!
      </p>
      <div className="inline-flex items-center gap-2 bg-red-50 border border-red-200 rounded-xl px-5 py-3">
        {[
          { val: pad(hours), label: "ಗಂಟೆ" },
          { val: pad(minutes), label: "ನಿಮಿಷ" },
          { val: pad(seconds), label: "ಸೆಕೆಂಡ್" },
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="flex flex-col items-center">
              <span
                data-testid={`countdown-${["hours", "minutes", "seconds"][i]}`}
                className="countdown-digit text-2xl md:text-3xl font-bold text-red-600 bg-white rounded-lg px-3 py-1 shadow-sm min-w-[3rem] text-center"
              >
                {item.val}
              </span>
              <span className="text-xs text-red-500 mt-1 body-font">{item.label}</span>
            </div>
            {i < 2 && <span className="text-red-400 text-2xl font-bold mb-4">:</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
